import idx from "idx"

import { formatDate, formatSlug } from "@jsUtils"

function transform(props) {
  const { linkText, styles, data, hasCategory, hasCopy, hideDate, color, filter } = props

  // console.log("storyblock factory:", props)

  const rawSlug = idx(data, _ => _.slug)
  const rawCategory = idx(data, _ => _.category)
  const rawExcerpt = idx(data, _ => _.excerpt.excerpt)

  const content = {
    author: idx(data, _ => _.author.name),
    id: idx(data, _ => _.id),
    category: rawCategory,
    thumbnail: idx(data, _ => _.thumbnail),
    date: formatDate(idx(data, _ => _.date)),
    title: idx(data, _ => _.title),
    copy: rawExcerpt,
    slug: `/${formatSlug(rawCategory)}/${rawSlug}`
  }

  return {
    linkText,
    filter,
    color,
    story: {
      ...content
    },
    hasCategory: !!hasCategory,
    hasCopy: !!hasCopy && !!rawExcerpt,
    hideDate: !!hideDate,
    importedStyle: styles || {}
  }
}

export default { transform }
